import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const baseUrl = "https://qltp.adfilex.vn";
const baseUrlService = "";
const baseApiUrl = "/api/revenue/receipt/searchPayment";
const getService = "/api/revenue/receipt/paidService";
const paiFeeType = "/api/revenue/receipt/paidFeeType";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class FileApi {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getFileByid(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/file/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getFileByidToServices(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseUrlService + `/api/files/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public UploadFile(file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/file/upload`, file)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // public dowloadfile(id): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     this.get(`/api/file/download/${id}`)
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }
  public dowloadfile(file) {
    let id = file.file_id;
    var a = document.createElement("a");
    a.href = `/api/file/download/${id}`;
    console.log(file.name);
    a.download = file.name;
    a.click();
  }
}
